export const SET_AUTH = "SET_AUTH";
export const CLEAR_AUTH = "CLEAR_AUTH";
export const SET_LOGOUT_INFO = "SET_LOGOUT_INFO";
export const SET_AUTHTOKEN="SET_AUTHTOKEN"